import { Component } from '@angular/core';

@Component({
  selector: 'app-style-page-containers',
  templateUrl: './style-page-containers.component.html',
  standalone: false,
})
export class StylePageContainersComponent {}
